import { CmdkItem } from "@seamapi/react-cmdk"
import { ComponentProps } from "react"
import { cn } from "src/ui/utils"

export type CmdkOptionProps = Omit<ComponentProps<"button">, "onSelect"> & {
  index: number
  focused: boolean
  item: CmdkItem
  onSelect: (item: CmdkItem) => void
  onSetFocusIndex: (index: number) => void
}

export function CmdkOption(props: CmdkOptionProps) {
  const { index, focused, item, onSelect, onSetFocusIndex, ...attrs } = props

  return (
    <button
      type="button"
      role="option"
      aria-selected={focused}
      id={`cmdk-option-${item.id}`}
      tabIndex={0}
      onClick={() => {
        onSelect(item)
      }}
      onFocus={() => {
        onSetFocusIndex(index)
      }}
      onMouseEnter={() => {
        onSetFocusIndex(index)
      }}
      data-focused={focused ? "true" : undefined}
      data-option-index={index}
      className={cn(
        "w-full h-11 shrink-0 gap-3 grow-0 rounded-lg text-[15px] flex flex-row items-center justify-start px-3 text-foreground",
        "data-[focused]:bg-accent data-[focused]:text-accent-foreground"
      )}
    >
      <span className="shrink-0 aspect-square size-5 [&_path]:text-muted-foreground [&_svg]:size-[18px] inline-grid place-items-center">
        {item.icon}
      </span>

      <span className="basis-0 grow truncate inline-block text-left">
        {item.label}
      </span>

      {item.detail && (
        <span className="truncate text-xs rounded-lg text-muted-foreground px-2 py-1 ml-auto">
          {item.detail}
        </span>
      )}
    </button>
  )
}
